import { faDogLeashed } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from 'components/Activities/Timeline/NoResults/ActivityTimelineNoResults.module.scss';
import React from 'react';

export const ActivityTimelineNoResults: React.FC = () => {
    return (
        <div className={styles.root}>
            <div className={styles.icon}>
                <FontAwesomeIcon icon={faDogLeashed} />
            </div>

            <h2 className={styles.title}>No Activities Found</h2>
            <p>We couldn’t find any records matching your selection.</p>
        </div>
    );
};
